import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      meta: {
        title: "",
        Description: "",
        Keywords: "",
        component: "appPageHome",
        index: 0,
        headerColor: "clear"
      }
    },
    {
      path: "/about-salameh",
      name: "aboutsalameh",
      meta: {
        title: "",
        Description: "",
        Keywords: "",
        component: "appPageAbout",
        index: 0,
        headerColor: "clear"
      }
    },
    {
      path: "/salameh-catering/services",
      name: "sectors",
      meta: {
        title: "",
        Description: "",
        Keywords: "",
        component: "appPageSectors",
        index: 1,
        headerColor: "clear"
      }
    },
    {
      path: "/salameh-catering/catering-setup",
      name: "cateringsetup",
      meta: {
        title: "",
        Description: "",
        Keywords: "",
        component: "appPageRepairAndRefit",
        index: 2,
        headerColor: "clear"
      }
    },
    {
      path: "/salameh-catering/salameh-kitchen",
      name: "kitchen",
      meta: {
        title: "",
        Description: "",
        Keywords: "",
        component: "appPageInnovations",
        index: 3,
        headerColor: "clear"
      }
    },
    {
      path: "/salameh-catering/salameh-kitchen/:slug",
      name: "kitchenInside",
      meta: {
        title: "",
        Description: "",
        Keywords: "",
        component: "appPageInnovations",
        index: 3,
        headerColor: "clear"
      }
    },
    {
      path: "/salameh-catering/products",
      name: "salamehproducts",
      meta: {
        title: "",
        Description: "",
        Keywords: "",
        component: "appPageProduct",
        index: 4,
        headerColor: "clear"
      }
    },
    
    {
      path: "/salameh-catering/we-cater/:cat",
      name: "appetizers",
      meta: {
        title: "",
        Description: "",
        Keywords: "",
        component: "appPageAppetizers",
        index: 4,
        headerColor: "clear"
      }
    },
    {
      path: "/salameh-catering/media-news",
      name: "medianews",
      meta: {
        title: "",
        Description: "",
        Keywords: "",
        component: "appPageNews",
        index: 5,
        headerColor: "clear"
      }
    },
    {
      path: "/salameh-catering/contact",
      name: "Contact",
      meta: {
        title: "",
        Description: "",
        Keywords: "",
        component: "appPageContact",
        index: 6,
        headerColor: "clear"
      }
    }, 
    {
      path: "/salameh-catering/subsidiaries",
      name: "subsidiaries",
      meta: {
        title: " ",
        Description: "",
        Keywords: "",
        component: "appPageSubsidiaries",
        index: 7,
        headerColor: "clear"
      }
    },
    {
      path: "/terms-and-conditions",
      name: "me",
      meta: {
        title: "Resource Group | Terms and conditions",
        component: "appPageTermsAndConditions",
        index: 8,
        headerColor: "clear"
      }
    },
    {
      path: "*",
      name: "404",
      meta: {
        component: "appPage404",
        title: "Marine Holdings  | 404",
        headerColor: "clear"
      }
    }
  ]
});
